// import { useEffect, useState, useRef } from "react";
// import { Link, useLocation, matchPath } from "react-router-dom";
// import logo from "../../assets/logo.png";
// import { NavbarLinks } from "../../data/navbar-links";
// import { subLinks } from "../../data/course-links";
// import { BsChevronDown } from "react-icons/bs";
// import { AiOutlineMenu } from "react-icons/ai";
// import useOnClickOutside from "../../hooks/useOnClickOutside";

// const Navbar = () => {
//   const location = useLocation();
//   const [open,setOpen] = useState(false);
//   const ref = useRef(null)

//   useOnClickOutside(ref, () => setOpen(false))
//   const matchRoute = (route) => {
//     return matchPath({ path: route }, location.pathname)
//   }
//   return (
//     <div
//       className={`flex h-14 items-center justify-evenly border-b-[1px] border-b-richblack-700 
//                   transition-all duration-200 ${
//                     location.pathname !== "/" ? "bg-richblack-800" : ""
//                   } transition-all duration-200`}
//     >
//       <div className="flex w-11/12 max-w-maxContent items-center justify-between">
//         {/* Logo */}
//         <Link to={"/"}>
//           <img src={logo} alt="Logo" width={160} height={32} loading="lazy" />
//         </Link>

//         {/* Navigation links */}
//         <nav className="hidden md:block">
//           <ul className="flex gap-x-6 text-richblack-25">
//             {NavbarLinks.map((link, index) => (
//               <li key={index} className="relative">
//                 {link.title === "Courses" ? (
//                   <>
//                     <div
//                       className={`group relative flex cursor-pointer items-center gap-1 ${
//                         matchRoute("/courses/:courseName")
//                           ? "text-yellow-25"
//                           : "text-richblack-25 hover:text-white"
//                       }`}
//                     >
//                       <p>{link.title}&nbsp;</p>
//                       <BsChevronDown />
//                       <div className="invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] translate-x-[-50%] translate-y-[3em] flex-col rounded-lg bg-richblack-5 p-4  opacity-0 transition-all duration-150 group-hover:visible group-hover:translate-y-[1.65em] group-hover:opacity-100 lg:w-[300px]">
//                         <div className="absolute left-[50%] top-0 -z-10 h-7 w-7 translate-x-[80%] translate-y-[-40%] rotate-45 select-none rounded bg-richblack-5"></div>
//                         {
//                           <>
//                             {subLinks?.map((subLink, i) => (
//                               <div
//                                 key={i}
//                                 className="rounded-lg bg-transparent hover:bg-richblack-25 border-b-2 py-4 pl-4"
//                               >
//                                 <p className="text-richblack-900 font-bold">
//                                   {subLink.name}
//                                 </p>
//                                 <ul className="pl-4">
//                                   {subLink.courses.map((course, j) => (
//                                     <li
//                                       key={j}
//                                       className="text-sm text-richblack-900 hover:text-yellow-200"
//                                     >
//                                       <Link
//                                         to={`/courses/${course
//                                           .split(" ")
//                                           .join("-")
//                                           .toLowerCase()}`}
//                                       >
//                                         {course}
//                                       </Link>
//                                     </li>
//                                   ))}
//                                 </ul>
//                               </div>
//                             ))}
//                           </>
//                         }
//                       </div>
//                     </div>
//                   </>
//                 ) : (
//                   <Link to={link?.path}>
//                     <p
//                       className={`${
//                         matchRoute(link?.path)
//                           ? "text-yellow-25"
//                           : "text-richblack-25 hover:text-white"
//                       }`}
//                     >
//                       {link.title}
//                     </p>
//                   </Link>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </nav>

//         {/* Blogs */}
//         <div className="hidden items-center gap-x-4 md:flex">
//           <Link to="/blogs">
//             <button className="rounded-[8px] border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-richblack-100 hover:border-white hover:text-white">
//               Our Blogs
//             </button>
//           </Link>
//         </div>

//         {/* Mobile Courses Dropdown */}
//         <div className="md:hidden relative group">
//           <div
//             className={`flex cursor-pointer items-center gap-1 ${
//               matchRoute("/courses/:courseName")
//                 ? "text-yellow-25"
//                 : "text-richblack-25"
//             }`}
//           >
//             <p>Courses</p>
//             <BsChevronDown />
//           </div>
//           <div className="invisible absolute left-[30%] top-[50%] z-[1000] flex w-[300px] translate-x-[-50%] translate-y-[3em] flex-col rounded-lg bg-richblack-5 p-4 opacity-0 transition-all duration-150 group-hover:visible group-hover:translate-y-[1.65em] group-hover:opacity-100">
//             <div className="absolute left-[50%] top-0 -z-10 h-6 w-6 translate-x-[80%] translate-y-[-40%] rotate-45 select-none rounded bg-richblack-5"></div>
//             {subLinks?.map((subLink, i) => (
//               <div
//                 key={i}
//                 className="rounded-lg bg-transparent hover:bg-richblack-25 border-b-2 py-4 pl-4"
//               >
//                 <p className="text-richblack-900 font-bold">
//                   {subLink.name}
//                 </p>
//                 <ul className="pl-4">
//                   {subLink.courses.map((course, j) => (
//                     <li
//                       key={j}
//                       className="text-sm text-richblack-900 hover:text-yellow-200"
//                     >
//                       <Link
//                         to={`/courses/${course
//                           .split(" ")
//                           .join("-")
//                           .toLowerCase()}`}
//                       >
//                         {course}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Hamburger Menu Button */}
//         <button
//           className="relative mr-1 md:hidden"
//           onClick={() => setOpen(true)}
//         >
//           <div className="flex items-center gap-x-1">
//             <AiOutlineMenu fontSize={24} fill="#AFB2BF" />
//           </div>
//           {open && (
//             <div
//               onClick={(e) => e.stopPropagation()}
//               className="absolute top-[118%] right-0 z-[1000] divide-y-[1px] divide-richblack-700 w-[120px] overflow-hidden rounded-md border-[1px] border-richblack-700 bg-richblack-800 "
//               ref={ref}
//             >
//               {NavbarLinks.map((link, index) => (
//                 <li key={index} className="list-none">
//                   {link.title === "Courses" ? (
//                     <></>
//                   ) : (
//                     <Link to={link?.path}>
//                       <p
//                         className={`${
//                           matchRoute(link?.path)
//                             ? "text-yellow-25 py-2"
//                             : "text-richblack-25 py-2"
//                         }`}
//                       >
//                         {link.title}
//                       </p>
//                     </Link>
//                   )}
//                 </li>
//               ))}
//             </div>
//           )}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Navbar;


import React, { useState, useEffect, useRef } from 'react';
import { NavLink} from 'react-router-dom';
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import logo from '../../assets/logo.png';
import useOnClickOutside from "../../hooks/useOnClickOutside";

const Navbar = () => {
  const [isMenu, setIsMenu] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [activeMobileSubMenu, setActiveMobileSubMenu] = useState(null);
  const ref = useRef(null)

  useEffect(() => {
    if (isMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenu]);

  const toggleMenu = () => {
    setIsMenu(!isMenu);
    if (!isMenu) {
      setActiveMobileSubMenu(null);
    }
  };

  useOnClickOutside(ref, () => {
    setActiveSubMenu(null);
  });

  
  const toggleSubMenu = (menuName) => {
    setActiveSubMenu(activeSubMenu === menuName ? null : menuName);
  };

  const toggleMobileSubMenu = (menuName) => {
    setActiveMobileSubMenu(activeMobileSubMenu === menuName ? null : menuName);
  };

  const navItems = [
    {
      name: 'Home',
      path: '/',
      hasDropdown: false
    },
    {
      name: 'Courses',
      path: '#',
      hasDropdown: true,
      subItems: [
        {
          title: "IT Service Management",
          items: [
            { name: "ITIL 4 Foundation", path: "/courses/itil-4-foundation" },
            { name: "SIAM Foundation", path: "/courses/siam-foundation" }
          ]
        },
        {
          title: "DevOps",
          items: [
            { name: "DevOps Foundation", path: "/courses/devops-foundation" },
            { name: "SRE Foundation", path: "/courses/sre-foundation" }
          ]
        },
        {
          title: "Project Management",
          items: [
            { name: "PMP Training", path: "/courses/pmp-training" },
            { name: "PRINCE2® Foundation", path: "courses/prince2®-foundation" }
          ]
        },
        {
          title: "Cloud And AWS",
          items: [
            { name: "AWS Solution Architect Associates", path: "/courses/aws-solution-architect-associates" },
            { name: "Microsoft Azure Architect 304", path: "/courses/microsoft-azure-architect-304" }
          ]
        },
        {
          title: "Generative AI",
          items: [
            { name: "GenAI In Project Management", path: "/courses/genai-project-management" },
            { name: "Prompt Engineering", path: "/courses/prompt-engineering" }
          ]
        },
        {
          title: "BI and Visualization",
          items: [
            { name: "Tableau Training", path: "/courses/tableau-training" },
            { name: "PowerBI Training", path: "courses/powerbi-training" }
          ]
        },
        {
          title: "Data Science",
          items: [
            { name: "Python Programming", path: "/courses/python-programming" },
            { name: "SQL for Data Science", path: "/courses/sql-for-ds" }
          ]
        },
        {
          title: "Artificial Intelligence",
          items: [
            { name: "Machine Learning", path: "/courses/machine-learning" },
            { name: "Natural Language Processing", path: "/courses/nlp" },
            { name: "Time Series", path: "/courses/time-series" },
            { name: "MLOps", path: "/courses/mlops" }
          ]
        }
      ]
    },
    {
      name: 'Projects',
      path: '#',
      hasDropdown: true,
      subItems: [
        { name: 'BTech Projects', path: '/projects/b-tech' },
        { name: 'MTech Projects', path: '/projects/m-tech' },
        { name: 'MBA Projects', path: '/projects/mba' }
      ]
    },
    {
      name: 'Internships',
      path: '#',
      hasDropdown: true,
      subItems: [
        { name: 'Summer Internships', path: '/internships/summer' },
        { name: 'Winter Internships', path: '/internships/winter' },
        { name: 'Industry Projects', path: '/internships/industry' }
      ]
    },
    {
      name: 'PhD Guidance',
      path: '#',
      hasDropdown: true,
      subItems: [
        { name: 'Research Based PhD Admission', path: '/phd/phd-admission' },
        {name:'Honarary Ph.D Admission', path:'/phd/honarary-phd'},
        { name: 'Thesis Writing', path: '/phd/thesis-writing' },
        { name: 'Dissertation', path: '/phd/dissertation' },
        { name: 'Paper Publication Support', path: '/phd/paper-publication' },
        { name: 'Writing Services', path: '/phd/writing-services' },
        { name: 'Documentation Support', path: '/phd/documentation-support' },
      ]
    },
    // {
    //   name: 'DBA Guidance',
    //   path: '/dba',
    //   hasDropdown: false
    // },
    {
      name: 'Careers',
      path: '/careers',
      hasDropdown: false
    },
    {
      name: 'Blogs',
      path: '/blog',
      hasDropdown: false
    },
    {
      name: 'About',
      path: '/about',
      hasDropdown: false
    },
    {
      name: 'Contact',
      path: '/contact',
      hasDropdown: false
    }
  ];
  

  return (
    <>
      {/* Added a spacer div to prevent content from hiding behind fixed navbar */}
      <div className="h-16"></div>
      
      <header className="fixed top-0 left-0 right-0 bg-richblack-900 border-b border-richblack-700 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex-shrink-0 ">
              <NavLink to="/" className="shadow-blue-200 shadow-[10px_-5px_50px_-5px]">
                <img src={logo} alt="logo" className="h-8" />
              </NavLink>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-richblack-25 hover:text-white"
              >
                {isMenu ? <FiXCircle size={24} /> : <FiAlignRight size={24} />}
              </button>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:block" ref={ref}>
        <ul className="flex space-x-8">
          {navItems.map((item, index) => (
            <li key={index} className="relative group">
              {item.hasDropdown ? (
                <div
                onMouseEnter={() => toggleSubMenu(item.name)}
                onMouseLeave={() => toggleSubMenu(null)}>
                  <button
                    onClick={() => toggleSubMenu(item.name)}
                    className="flex items-center space-x-1 text-richblack-25 hover:text-richblue-300"
                  >
                    <span>{item.name}</span>
                    <FiChevronDown />
                  </button>
                  <div className={`absolute left-0 mt-2 ${item.name === 'Courses' ? 'w-[540px]' : 'w-[270px]'} rounded-md shadow-lg bg-richblue-5 ring-1 ring-black ring-opacity-5 transition-all duration-200 z-50 ${
                    activeSubMenu === item.name ? 'opacity-100 visible' : 'opacity-0 invisible'
                  }`}>
                    {item.name === 'Courses' ? (
                      <div className="py-4 grid grid-cols-2 gap-x-4 gap-y-2">
                        {item.subItems.map((section, sectionIndex) => (
                          <div 
                            key={sectionIndex} 
                            className="px-4 pb-2 border-b border-richblue-200 last:border-b-0"
                          >
                            <h3 className="text-richblue-700 font-semibold mb-2">
                              {section.title}
                            </h3>
                            <div className="space-y-1">
                              {section.items.map((subItem, subIndex) => (
                                <NavLink
                                  key={subIndex}
                                  to={subItem.path}
                                  className="block text-sm text-richblue-400 hover:text-richblue-600 hover:bg-richblue-25 px-2 py-1 rounded"
                                  onClick={() => setActiveSubMenu(null)}
                                >
                                  {subItem.name}
                                </NavLink>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="py-1">
                        {item.subItems.map((subItem, subIndex) => (
                          <NavLink
                            key={subIndex}
                            to={subItem.path}
                            className="block px-4 py-2 text-sm text-richblue-600 hover:bg-richblue-25"
                            onClick={() => setActiveSubMenu(null)}
                          >
                            {subItem.name}
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ) : (

                      <NavLink
                        to={item.path}
                        className={({ isActive }) =>
                          `text-richblack-25 hover:text-richblue-300 ${isActive ? 'text-richblue-300' : ''}`
                        }
                      >
                        {item.name}
                      </NavLink>
                    )}
                  </li>
                ))}
              </ul>
            </nav>


            {/* Mobile Navigation */}
            <div 
              className={`fixed top-16 left-0 right-0 bottom-0 bg-richblack-800 md:hidden transition-all duration-300 z-40 ${
                isMenu ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
              }`} 
            >
              <div className="h-full overflow-y-auto pb-20 overscroll-contain">
                <ul className="px-4 pt-2 pb-3 space-y-1">
                  {navItems.map((item, index) => (
                    <li key={index} className="relative">
                      {item.hasDropdown ? (
                        <div>
                          <button
                            onClick={() => toggleMobileSubMenu(item.name)}
                            className="flex items-center justify-between w-full px-3 py-2 text-richblack-25 hover:text-richblue-300"
                          >
                            <span>{item.name}</span>
                            <FiChevronDown className={`transform transition-transform duration-200 ${
                              activeMobileSubMenu === item.name ? 'rotate-180' : ''
                            }`} />
                          </button>
                          {activeMobileSubMenu === item.name && (
                            <div className="bg-richblack-700 transition-all duration-200">
                              {item.name === 'Courses' ? (
                                // Courses submenu
                                <>
                                  {item.subItems.map((section, sectionIndex) => (
                                    <div key={sectionIndex} className="px-4 py-2 border-b border-richblack-600">
                                      <h3 className="text-richblue-400 font-semibold mb-1">
                                        {section.title}
                                      </h3>
                                      {section.items.map((subItem, subIndex) => (
                                        <NavLink
                                          key={subIndex}
                                          to={subItem.path}
                                          className="block px-4 py-1 text-sm text-richblack-25 hover:text-richblue-300"
                                          onClick={() => {
                                            setActiveMobileSubMenu(null);
                                            setIsMenu(false);
                                          }}
                                        >
                                          {subItem.name}
                                        </NavLink>
                                      ))}
                                    </div>
                                  ))}
                                </>
                              ) : (
                                // Other submenus
                                <>
                                  {item.subItems.map((subItem, subIndex) => (
                                    <NavLink
                                      key={subIndex}
                                      to={subItem.path}
                                      className="block px-8 py-2 text-sm text-richblack-25 hover:text-richblue-300"
                                      onClick={() => {
                                        setActiveMobileSubMenu(null);
                                        setIsMenu(false);
                                      }}
                                    >
                                      {subItem.name}
                                    </NavLink>
                                  ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      ) : (
                        <NavLink
                          to={item.path}
                          className={({ isActive }) =>
                            `block px-3 py-2 text-richblack-25 hover:text-richblue-300 ${
                              isActive ? 'text-richblue-300' : ''
                            }`
                          }
                          onClick={() => setIsMenu(false)}
                        >
                          {item.name}
                        </NavLink>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
            

export default Navbar;

